import request from '../index'

// 获取故事列表（后台管理）
export const getStoriesList = (params) => 
  request.get('/stories/admin/list', { params })

// 获取故事详情（后台管理）
export const getStoryDetail = (id) => 
  request.get(`/stories/admin/${id}`)

// 创建故事
export const createStory = (data) => 
  request.post('/stories/admin/create', data)

// 编辑故事
export const updateStory = (id, data) => 
  request.put(`/stories/admin/${id}`, data)

// 删除故事
export const deleteStory = (id) => 
  request.delete(`/stories/admin/${id}`)

// 审核故事
export const auditStory = (id, status, rejectReason) => 
  request.put(`/stories/admin/${id}/audit`, { status, rejectReason })

// 设置/取消精选
export const setFeatured = (id, isFeatured) => 
  request.put(`/stories/admin/${id}/featured`, { isFeatured })

// 批量操作
export const batchAction = (ids, action) => 
  request.post('/stories/admin/batch', { ids, action })

// 获取统计数据
export const getStoryStats = () => 
  request.get('/stories/admin/stats')
